import { populate } from 'populate';
import dragonBones from 'pixi-dragonbones';

const raw = {
    className: 'WorldLayout26',
    width: 0,
    height: 0,
    x: 50,
    y: 100,
    list: [
        {
            id: '1',
            type: 'Container',
            name: 'root',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '',
            data: '',
        },
        {
            id: '2',
            type: 'Container',
            name: 'backgrounds',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '1',
            data: '',
        },
        {
            id: '3',
            type: 'Container',
            name: 'nodesContainer',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '1',
            data: '',
        },
        {
            id: '4',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '1',
            data: '',
        },
        {
            id: '5',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '1',
            data: '',
        },
        {
            id: '6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map_26_export_1',
            parent: '2',
            data: '',
        },
        {
            id: '7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1351,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map_26_export_2',
            parent: '2',
            data: '',
        },
        {
            id: '8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2702,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map_26_export_3',
            parent: '2',
            data: '',
        },
        {
            id: '10',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5404,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map_26_export_5',
            parent: '2',
            data: '',
        },
        {
            id: '9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4053,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map_26_export_4',
            parent: '2',
            data: '',
        },
        {
            id: '9f0cb310-b23d-4e3f-b2a4-8ab9baf4013b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6755,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map_26_export_6',
            parent: '2',
            data: '',
        },
        {
            id: '12',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8106,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map_26_export_7',
            parent: '2',
            data: '',
        },
        {
            id: '13',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9457,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map_26_export_8',
            parent: '2',
            data: '',
        },
        {
            id: '56df0195-6463-44b9-940d-5d3496e6e0cd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 364,
            y: 464,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '7a9205ef-4579-4e48-91ca-758759875fca',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 435,
            y: 515,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'bb2a80ae-656a-4047-ac57-3150a1cb4347',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 530,
            y: 507,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c80ab6c5-8da6-452a-8f78-8cdfb39b47f8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 610,
            y: 462,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'fe928222-7c7e-4930-9bd4-a09d22bfaa98',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 675,
            y: 403,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'fcbae5c4-242e-45c3-8498-dd3016bea818',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 738,
            y: 342,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '1841fb74-3546-4b1a-89e0-6f7bd127ecf1',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 815,
            y: 298,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4c23f767-4046-4514-aa3a-bf777714bf37',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 899,
            y: 333,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '08d6b9dd-5b5d-4dcb-ab64-33043bc06461',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 946,
            y: 400,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'bfa1ca53-090d-4de3-acdb-fd316fc88be1',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 999,
            y: 468,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '7dfa1241-8d82-4ea0-9218-fadc226e2f04',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1070,
            y: 520,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '3d4b2d36-3151-40a2-b0a5-cdfacff94eca',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1161,
            y: 545,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ac529493-0136-425d-8cc2-c38bb84fd75e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1221,
            y: 481,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '9bd8d203-22d9-42ff-94a9-4991ecb8d3bf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1270,
            y: 409,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '162483f4-6daa-46de-85b1-790bf3432c36',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1342,
            y: 351,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '44fae2a0-3ed6-4fa4-be5c-3ae3e6e8c724',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1427,
            y: 316,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'd336c8c5-c147-4bc6-ad55-3517beecd5aa',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1524,
            y: 320,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '864900ac-f0a8-4510-a465-2bb18ee1da3b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1607,
            y: 362,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4485c551-6650-475c-ab0a-5ce4fa07c51d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1686,
            y: 410,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c7c8d637-c522-4190-b7fc-4e386affcd56',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1777,
            y: 433,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'e851c9ef-ece6-42ff-960b-3ff033aab481',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1873,
            y: 435,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '3adbe6ad-ad49-4bbb-b9e6-a61103b8108a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1969,
            y: 432,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '3bd32a9f-4109-4094-8359-e47992bac72d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2047,
            y: 384,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b5068473-8cc8-4ccb-815f-3aae2a28ebaa',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2138,
            y: 357,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '7b0248d7-ee01-415c-a331-45831d358fe7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2233,
            y: 338,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a1dea66a-e264-4ce2-8797-28674a3d2c3e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2331,
            y: 336,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'fb82e513-3ba3-48f0-9b2e-58122c2b9327',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2424,
            y: 362,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '8122caa6-9e9c-4bc0-a793-c84e70b93231',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2501,
            y: 409,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a5c6c647-d349-459b-aa80-137bd60483fd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2576,
            y: 460,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '42fec6fe-a245-43e4-a141-e231811c848e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2671,
            y: 467,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '1f4d2897-1892-48bf-bfa7-f3f94af6f15a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2764,
            y: 445,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'e1b70666-2a0a-482b-b93d-5f83aa5b03ef',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2860,
            y: 445,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '717479c5-cdd2-4ba5-a881-163ecf870a05',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2953,
            y: 460,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b71953a3-0840-42ba-be89-0ed714843154',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3029,
            y: 506,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ff822db4-8f73-4987-87d2-392d1e5c4c3a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3123,
            y: 495,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4bfb04a7-c8a9-4c07-9b82-b3e96b08bda0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3220,
            y: 497,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '24ab40ec-06c1-4c12-a2d6-eacee8a3f690',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3316,
            y: 493,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '63d5dd2c-5bfa-41f8-b9d2-fe971b0f19ee',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3402,
            y: 461,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4887b6c4-a491-4d99-a0a1-66adb7c0ab91',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3482,
            y: 411,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '25ba300d-0caa-4f7e-babf-a3d2a24b8250',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3562,
            y: 368,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f5de8c5f-ab5c-4e00-aad3-d42cbd702da0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3641,
            y: 323,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f5951376-adfa-4668-89e0-6e9dd0532a92',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3721,
            y: 366,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '519958b4-c1a5-4e43-a5db-a5adbb068bb9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3794,
            y: 418,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '98e28a5f-c06d-410f-a0cf-0912eb50e777',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3892,
            y: 413,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ac4ff3e6-7294-4675-b15a-671156a1786a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3978,
            y: 375,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c647797d-31f2-4174-bb56-8373f8edcbbf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4055,
            y: 329,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4000e26e-5b95-4a98-b7f1-d92fc399c8d2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4142,
            y: 300,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'bae16908-8751-4267-921a-3dcaa5053c85',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4232,
            y: 279,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ff791fb3-dd64-48db-9227-438970a7eb21',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4326,
            y: 276,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '2917d442-4e1a-45cf-a6fb-97106365690a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4421,
            y: 279,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '73c608c4-73a1-400b-afa1-bcd43871746b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4511,
            y: 303,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '0a8a9322-8585-4b36-9f6c-0d1ba784c97b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4591,
            y: 345,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '05b71be5-a2df-4894-9ef2-9e2ef109d689',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4679,
            y: 376,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '508af7f1-b5a4-4e45-87c2-6d5db9cb39b7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4772,
            y: 390,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '9dc515b9-ec92-4e4f-a652-e3f87c5a8c28',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4865,
            y: 402,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b4d615d1-6971-47af-9eb9-88a724ef41a0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4957,
            y: 426,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '880990c4-c556-4d8d-b012-86dfd93e7858',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5052,
            y: 421,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '7c651cf4-75a6-4491-826a-6c28018fa2c3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5146,
            y: 405,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a513f501-d5cb-4ad0-9285-58d933979033',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5242,
            y: 407,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '8196c2a9-9165-46c4-beed-7c535cdedd1a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5336,
            y: 421,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f1dac610-c069-4d53-ba3b-f6d1866c8cd8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5425,
            y: 451,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c0fc3932-a1de-444b-930e-bcf01ddc4307',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5519,
            y: 469,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '44938315-e221-4adc-af04-7f3af7448130',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5612,
            y: 460,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'e86ff575-c1e3-4aac-b6c3-fe23ca58377f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5703,
            y: 445,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '89310bf6-3feb-47c5-9712-581fe0bc3165',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5794,
            y: 462,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c9dff7a8-77c2-4f15-987d-1a8abaf613d6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5882,
            y: 489,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'fd3a27a5-0b6a-4fa9-b77c-1077ffd93405',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5976,
            y: 482,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '9cf01239-ae9b-472d-9d46-1b2626eb2eff',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6052,
            y: 434,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '3a5e4739-3544-499a-a6fd-ca6c3731a910',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6133,
            y: 394,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c614dd38-b1cf-428d-b32c-47e5a8075630',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6226,
            y: 402,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a7d28664-7975-4713-81fa-724f5423f668',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6321,
            y: 400,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '47ad2bd2-c705-47c5-a3ee-12823a323908',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6405,
            y: 366,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '09eb9f50-5dd8-418f-ab6e-371c641bc419',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6481,
            y: 320,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '258c0e88-eed6-4bf9-ad4d-d374b9874ef1',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6568,
            y: 290,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '6b1d71e9-c584-4325-a73a-b9b55de14e31',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6662,
            y: 279,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '8373b8f8-e9ee-4534-b465-e56000164cb4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6759,
            y: 286,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '5644fd5f-102a-4b8c-941d-0e2eb5d7db25',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6845,
            y: 322,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '0de9cee0-b823-40ac-8a1c-78d6563f4737',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6928,
            y: 364,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '58879c0a-a4c7-41fa-98d6-8a51f0e7852d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7017,
            y: 392,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '12a93fa7-dd94-4406-8424-3e0ea180a142',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7114,
            y: 387,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'd7d51341-a098-4d4c-9812-7364da10aca0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7198,
            y: 345,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a181e382-d7f7-4eef-818c-dae536901874',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7283,
            y: 302,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '62691ac8-3e66-4014-b693-a0a0a11b9ed5',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7381,
            y: 305,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '3136c1a6-6c51-48db-87c0-0a2ed99f42bc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7470,
            y: 341,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b90cf5df-0034-436a-9b26-88674a5d1326',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7562,
            y: 373,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '205970ef-b77d-43c6-b32b-23f5373ecfe4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7656,
            y: 392,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '36ff4805-184d-455b-a91e-45b1e58c2866',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7753,
            y: 385,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '9926307f-6a1b-43df-9116-98dd0278741b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7845,
            y: 359,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ae0105e0-ee28-47cd-9711-5e0f57955f4a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7931,
            y: 323,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a776133c-1033-47b5-9691-095b8f120fe5',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8022,
            y: 304,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f4205742-1e0b-4b10-8e17-e8c91a12ef77',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8117,
            y: 292,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '32dd67ba-3e43-4613-aaef-38886398fc42',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8211,
            y: 291,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b44b0529-0878-450c-a49d-62ff2b1746e3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8301,
            y: 310,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '9a57beec-f74e-4fa7-92d1-dc72efdb727c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8389,
            y: 339,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'd3019d0f-f1a4-444d-a852-47eae3ea388e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8473,
            y: 376,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '22ca9d96-6052-49ed-83ce-6dc54983027c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8554,
            y: 414,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ee9d4a50-d074-446b-adee-077c8b1702bc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8647,
            y: 399,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '5580fb40-6044-4730-bfd5-90d5920ab5ad',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8742,
            y: 389,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a29e469c-b26e-4dc6-9c6e-46a717d82a85',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8836,
            y: 406,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '6bab8c76-9fe9-4c48-840d-6a1aece6b7e6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8924,
            y: 439,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '0c9272d4-e609-47ae-9cf0-83605299229e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9019,
            y: 436,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a1347d5e-4809-4008-b3d1-3377cf8c0833',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9102,
            y: 402,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '283e8a94-3688-4c20-9a92-984b0fe8416c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9184,
            y: 365,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '0119fc2a-b2c5-42f7-9874-e7c53ecfb870',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9275,
            y: 342,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '79b22a3b-9826-4faf-adb5-145f720ab239',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9372,
            y: 337,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'dca043d3-3d83-43cc-b0d6-edbfc6ba8a3d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9467,
            y: 352,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4c3f2c53-0255-4021-9e6a-4eb39f668bc0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9556,
            y: 383,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'dd09d760-82c3-43b1-9738-66fc4e96753a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9619,
            y: 446,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '594f0c9d-2203-4bae-9bcc-347660874387',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9676,
            y: 511,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '8a164856-2cd7-4e49-8788-815fb197dc04',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9769,
            y: 531,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'cb8a7cfc-bcc1-4498-b3d3-e3583f46b184',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9850,
            y: 487,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'abbc14b8-986c-4908-acda-7bb8f327aa1d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9945,
            y: 494,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '2bffbb89-0ede-4475-9b43-c6ce66f8cab9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10012,
            y: 436,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'bdd7b500-5985-4388-a1dc-f383b34cf6ce',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10079,
            y: 377,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'd1b0944d-6aa5-4f86-9b51-b1feef6709cd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10169,
            y: 352,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '5aeb7199-2ea4-4794-ae5d-843e0ac2ac67',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10250,
            y: 391,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '19e4772f-4442-435c-8bcd-25ff19792f03',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10301,
            y: 458,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'eb9569cb-09b3-4c06-b939-6c32ef612773',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10351,
            y: 526,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '1b5aa133-73ff-49d2-863a-915e86f3b541',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10442,
            y: 539,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '1c1c8bdb-ee6f-402b-8e77-a3c63f485601',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10492,
            y: 472,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '74',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '110',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '164',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '185',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '214',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '219',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '224',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '1b355a2e-d409-489c-8af4-a150c082b42b',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '106',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '160',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '181',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '210',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '215',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '220',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '225',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '230',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: 'a75fe524-8e1d-4935-b206-17a7c35bc961',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 453,
            y: 773,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'bd6910ad-ab94-4fdf-b173-3bbe410ba27a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 525,
            y: 716,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '86bd5728-42e1-4a90-8dc2-3003300529d5',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 596,
            y: 663,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'a1365384-1cbf-4c51-be8e-b2b30d366e9f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 666,
            y: 611,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '0766d287-6e42-484c-ab9d-a06c4d9a1f1e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 735,
            y: 559,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '874f70c5-2ede-4b94-8994-2fcc40012805',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 539,
            y: 802,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '13239d49-cee5-4014-878d-48776cd53a89',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 595,
            y: 750,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '1f04e3ba-5821-4d04-8e74-7b205a774492',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 665,
            y: 705,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'b67ad155-e330-441e-aa23-f2656e6328a8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 739,
            y: 646,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '7ccf5f99-9239-4b3c-aafd-5a903b8f2422',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 815,
            y: 585,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '16dcc931-3704-4470-9a96-f19295e06e3d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 677,
            y: 790,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'f20394f2-0488-4cd6-ae80-70e295863644',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 742,
            y: 740,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'e836e909-3402-430b-a6db-10fab1494586',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 812,
            y: 687,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'e23b0a97-0f92-4df3-9e46-8066e9539d99',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 886,
            y: 629,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '3b37df0e-7f9e-48fd-9e75-2aa2619d68b1',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 804,
            y: 783,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '78b9956a-4293-46e4-90f6-e4b16ac90fa5',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 872,
            y: 730,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '272ad13c-d045-4245-abc3-871e57926445',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 950,
            y: 675,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '2c3f5a4d-f5b4-403e-87eb-29cfa5356a74',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 944,
            y: 779,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '48f957ba-0768-4579-90a8-564127e64e2b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1011,
            y: 730,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '82630176-2990-4416-9aea-7563d486a8a8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 967,
            y: 133,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '5522b1cc-c396-460b-906b-938483614b57',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1033,
            y: 83,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'c328ae7d-e68b-4313-a00a-f031b93a1492',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1097,
            y: 40,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '51dd02a6-659d-4b16-9757-965fa88dbb38',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 965,
            y: 228,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '4fb13386-4659-45ef-9891-70016a0568c7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1028,
            y: 175,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '4fc6d165-9342-4939-8d5c-4bf3eccfd186',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1096,
            y: 127,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'fcdc3579-6352-43e4-b247-15988fd971da',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1167,
            y: 76,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'b588b39f-0e1f-4eb4-bff0-9ca2f7bf3e83',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1231,
            y: 27,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'c0945fac-069f-4fb7-972f-fac405ca9994',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1031,
            y: 271,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '3f988eb1-e3a6-4be2-82c2-82489347287d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1093,
            y: 222,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'd1ce05b5-3167-4392-8743-80081f3e06b6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1158,
            y: 175,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'b3fa3627-3ccd-4da4-8ceb-cf24ff04cdc2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1225,
            y: 126,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '5a405857-c7b9-4630-a09f-799af83646e0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1296,
            y: 68,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '58f54fc8-8bc3-4268-ad82-dcfc4ad75338',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1360,
            y: 23,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'b084d1db-af3a-435f-b790-0fdb89024be8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1079,
            y: 329,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'd9144a4a-1a7f-443b-a629-32f01f399e1e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1148,
            y: 279,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'd90b075b-2ac7-4e75-ac48-5b93f5dee9ad',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1209,
            y: 229,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'b16c6403-d25f-48de-abb3-b382a6951366',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1276,
            y: 181,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'b561fcfb-a80e-4e07-b918-2906358b2948',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1345,
            y: 121,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '3c6d824c-94de-4f59-80b1-28d706ba1461',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1406,
            y: 76,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '71229a3f-bfa3-4ed8-9186-504545e2706b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1126,
            y: 381,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'beef0248-c84c-4eec-87b2-51184e874a1e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1198,
            y: 335,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'efdcce33-f19a-4035-b648-d37d8f4545c8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1263,
            y: 285,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: 'd03ec3f1-fdcc-4eef-bb3b-7c77e3a6e910',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1335,
            y: 228,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '4f36471d-e61b-4a04-900c-53384c622f74',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1408,
            y: 167,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '74',
            data: '',
        },
        {
            id: '77d72e75-1448-4dda-94f1-ba3010d98cfa',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1337,
            y: 573,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'd58fcc88-8f35-4e4f-bea0-d02fab8c7b7e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1404,
            y: 522,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '13516c60-9677-4215-b4f7-269536803505',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1471,
            y: 466,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'e3d2d711-37bd-4bfd-b705-90cdb8ddfb1f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1381,
            y: 631,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'e25b1aa7-1c0a-492b-abab-a1c27c33e1ed',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1448,
            y: 581,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'd613dbd0-8957-4a5a-bdb9-b768ebd2d041',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1519,
            y: 521,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '58dcbe54-d1ca-471d-b15e-c78c3abb1ac3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1461,
            y: 653,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '93ec2181-6a15-4e7f-a6a8-7c9f0944d647',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1533,
            y: 596,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '3840ba54-b937-42df-a133-90ca9fc3252e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1606,
            y: 543,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'a31b99c9-3be7-448d-94b6-db20876de773',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1447,
            y: 746,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'ab1e0c4f-bcd5-40e8-a9a6-cad5564aa18b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1521,
            y: 695,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '5d2e12a8-9581-48a9-b882-e2006e7749e5',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1591,
            y: 637,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '35c7b608-7cc5-416b-b884-ec5d556bddea',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1661,
            y: 588,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'f7621387-c242-472c-9bbe-417085fbac1a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1520,
            y: 787,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '57fa0791-5308-46e0-a751-a5c0cfd29647',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1586,
            y: 735,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '70762ae8-0004-4b94-9a1c-b17bc22a0a4c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1656,
            y: 686,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'de9cf570-58b6-4792-b31f-169edced5281',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1728,
            y: 636,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '198810af-41f3-48ef-ae20-8e58590f2fec',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1786,
            y: 583,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '4e4614d7-13b1-43fb-8fea-bd05b4616c92',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1660,
            y: 779,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '32622642-8358-424c-82f7-6ef64f4b79cc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1726,
            y: 733,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '0894a7d8-6e01-4494-bee4-98ed91a27e18',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1793,
            y: 687,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'da70d0e7-56ad-4068-a247-a9df73120e0a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1856,
            y: 634,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '16101b9d-b7ad-49ec-8d04-30a13dd2618c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1706,
            y: 256,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '2a0b6747-e559-4e0e-8374-6f42813be5bb',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1772,
            y: 202,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '714b5420-11d9-4fa1-9e70-56e5e71ce842',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1844,
            y: 148,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'b5022711-bde4-4bda-9af0-29241e49e761',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1913,
            y: 100,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '4b3d2588-0688-4ab8-a77d-77a91fd033a3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1983,
            y: 50,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'bd525a32-865b-465a-985f-a65980bf22d5',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1748,
            y: 323,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '1e9a18b6-8f81-4bd9-b671-4ca397c050cb',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1818,
            y: 263,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'c573b8ab-04dc-4c9f-8a0b-f60a7f930464',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1885,
            y: 209,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'b04512bc-b417-4aae-a17a-89296269ae32',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1954,
            y: 160,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '81548beb-6e41-4920-a56f-a86a94b67986',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2021,
            y: 109,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'a36cc436-adf5-48e9-9508-2a349236c0e3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2088,
            y: 57,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '3d3f3898-3733-41a6-959e-d22a83f22172',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1848,
            y: 336,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'd80342a2-627a-4789-b311-625477524366',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1915,
            y: 278,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '860b6a90-1fd5-4fb3-a278-28879f88fd97',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1986,
            y: 230,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '3e3d18d4-3189-4c97-b7c4-58c5ee4ceedd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2051,
            y: 182,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '06554738-8dcc-4657-95b9-672ab73a635c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2113,
            y: 132,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '24d32ef4-4c0f-4b4e-a188-d8ae8f16c325',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2177,
            y: 85,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'bad876f1-9167-4fa0-86d9-dc97104601ac',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2235,
            y: 30,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'f44fedbb-38df-42b6-a33b-92eb47f638bf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2004,
            y: 311,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'e2d42bbd-0a63-4eaa-9ad3-d060cc6c9bfe',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2072,
            y: 257,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'ef0c9fad-c05d-4d23-ab52-17afba3acb06',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2136,
            y: 205,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'fbfcb4db-7dc5-42cb-b7ee-d8ff02299212',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2201,
            y: 160,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'dcfde3d3-68a7-4335-8b2e-a05b62d179e7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2269,
            y: 109,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '985d8516-6b75-4b19-a9da-833ae9f83d13',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2340,
            y: 53,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '9bbd07a7-5406-4208-8d93-0252fff36fe4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2059,
            y: 580,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '6da55226-2a72-4831-8491-a35bcb5677ad',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2128,
            y: 533,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '482ba032-60bd-448e-bc2e-3a177fa36a88',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2188,
            y: 484,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'a0d563c5-8f72-4dcb-bd36-c4845808a60c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1960,
            y: 753,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '9cc04c62-cdd6-4e83-bd25-0e983d897bf2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2026,
            y: 705,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '98eea980-6ee4-4d0c-99c2-d285ae3b3ab2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2093,
            y: 655,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'c6013a65-cce2-4740-8398-e73d936fc1a9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2157,
            y: 604,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'faecffea-b51e-485d-bc93-e4628f1edb46',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2219,
            y: 552,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '2ce7b2ad-40b7-4b71-aa41-db4f76f0b7d2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2282,
            y: 507,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'a4e4a4c6-d2fc-4039-a6c3-6ec01aff25f0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2339,
            y: 463,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '762dad2f-0d48-4f1f-b656-6b3da4b61571',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2052,
            y: 779,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'e4691618-51f5-4224-b17c-6ca309a8cd30',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2118,
            y: 724,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'e7d7dc42-52de-4ec0-8e2d-0fe94180dcb7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2190,
            y: 664,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '09cfa186-a0ae-4583-a5bd-fe44f5caac88',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2259,
            y: 617,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: 'c2c1929c-353a-433d-8ac4-77efcc711aee',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2323,
            y: 568,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '1fbb8bf6-a334-43b4-a7f2-2653fc31fed8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2388,
            y: 519,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '2bf4e829-2e0f-4372-b2df-adcf85c23b5e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2171,
            y: 786,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '8bde27e9-7b8e-46da-8f4e-473ce3bcc5e5',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2240,
            y: 734,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '83ba41f3-2d2b-4442-a9a4-2ffc4acc9f84',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2308,
            y: 679,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '794ab18d-3c42-448a-8b00-9f4b21c582cf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2375,
            y: 629,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '5ba0e8c0-3ade-49e9-aaea-67646ee90ad1',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2448,
            y: 579,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '148d4047-5ca7-48ae-b769-8f7863e28a63',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2311,
            y: 792,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '9fa05928-58d6-415f-9a3d-6bae8e6bfd32',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2370,
            y: 741,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_4',
            parent: '110',
            data: '',
        },
        {
            id: '7613867a-efe7-4e75-93fb-369ac14b471d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2786,
            y: 714,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'dbf4d27b-b5f3-4917-af77-53fd77d301e3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3332,
            y: 89,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'b278e8ff-6693-4766-9340-1507029d9f0d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4130,
            y: 79,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '1795fb53-cd90-430a-bfb9-dcb6a51f0895',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3744,
            y: 183,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'f67273b8-9381-406c-9bc0-968b22379668',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3870,
            y: 71,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '90029be4-bc72-4ce3-993a-9d2908fc2022',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3886,
            y: 324,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '9284b1c8-a7eb-4b83-aaac-74d413cc89db',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4028,
            y: 210,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '7e3a7617-6456-4bc1-84e8-63a71774d1a7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3596,
            y: 75,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '1d4acd8e-baba-4731-bb95-5f33fb4e1c0f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3475,
            y: 181,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '6b3e5758-f5be-420e-a3db-bb0527eab54d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3619,
            y: 275,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '08142080-552c-440f-b14b-c4ce80366ecd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4218,
            y: 211,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '20b7bcfc-1dba-4a23-a8b7-3a1054e26104',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3002,
            y: 773,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'bbaad227-e3f8-48fe-ac96-0e9af0f58539',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2658,
            y: 924,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '38d08d8d-9a12-4b37-8f52-85faaf88163d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4215,
            y: 575,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '0271e1b4-5f72-4a7b-88ab-59134e7deadc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4423,
            y: 730,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '185',
            data: '',
        },
        {
            id: 'e431f90a-c600-4382-913e-5f4a43004dd3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4458,
            y: 535,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '26fcd006-4637-4dc2-9df3-6196e9ebd7fc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4748,
            y: 651,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '233fc1d1-04c7-4743-ad5b-256939c75cb8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4174,
            y: 770,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '475a3d8d-b29d-402d-bbb5-07f105958268',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4673,
            y: 744,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '6752ca15-dd43-4733-a22e-4b406f70c40d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4887,
            y: 731,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '185',
            data: '',
        },
        {
            id: 'e535bb36-5137-434e-9ff9-d0b8a0be2410',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3984,
            y: 660,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '2dbce353-d6b9-40b5-b282-2b1ee0f7af54',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6026,
            y: 202,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '55302d23-b1f0-4593-9516-e6c6ed3de4d9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5976,
            y: 108,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '92b9e7d2-7ef2-4166-ae31-eb4c76b7b139',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5868,
            y: 43,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: 'b7ab0ed1-182e-4ed0-a976-353ec014688a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6153,
            y: 182,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '674fd647-f8ea-4114-bc3d-3590edb36376',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5754,
            y: 82,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: 'cc2749f6-1f92-4258-af25-c943a56aea36',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5847,
            y: 145,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '7ef819ff-7fea-4375-8ced-46d54b0389e3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5988,
            y: 317,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: 'c97845ed-8165-4ec7-a84e-309bf80b342d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5906,
            y: 240,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '5a8ca3ed-ed25-4ea0-a297-636cef18f41a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6338,
            y: 281,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: 'e60b3812-b6a1-48c9-a05f-bf064e287330',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6119,
            y: 293,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '3350a9a8-4851-4da3-b075-c25382243a8d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6230,
            y: 265,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '52779ae7-e108-4836-a401-fe9c08bec44d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6406,
            y: 203,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: 'd9fa8d3f-7c36-4c21-82c9-d8e9a6cf0a6c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6340,
            y: 94,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '609e13e7-df04-4f96-a585-1a808e296eb1',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6281,
            y: 175,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: 'f423df96-47ac-4bf6-aa05-6f32d0c68fe4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6099,
            y: 86,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: 'f4ade4dc-6dc0-4e77-bf4b-fd04b1f94458',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6229,
            y: 76,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '9a173c21-6d9e-4523-86e2-02f80cf1061f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5675,
            y: 796,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: 'a041bda7-ba6c-4d2b-888a-0a15d2e582a2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5759,
            y: 728,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '069b1dd3-8c34-4629-9b85-f9286e015115',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5847,
            y: 663,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '968045ec-709c-45c8-9072-757639748b25',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5810,
            y: 827,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '30aa5d0f-ea1d-496e-bd79-b70b0e984352',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5897,
            y: 765,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: 'f74ab1d8-27cb-4944-a46e-1ced49ca8626',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5983,
            y: 696,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '32605d67-a94a-41bd-8b72-bb8cbf1b5073',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6071,
            y: 634,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '46fc61f0-35b2-404c-9d38-4d420870e984',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6168,
            y: 582,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '1b0dc980-eeb7-486a-bc8a-c232c7af6555',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6021,
            y: 804,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '901aad91-504c-40c9-89cc-e0812d8fb7ce',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6110,
            y: 738,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '430d5c45-23a9-4ac6-b8f8-6c24a41180cc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6201,
            y: 680,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '164925b2-66d0-4417-9077-742b4ae510c1',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6291,
            y: 611,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: 'dac9f68f-941e-4e72-a8d1-5d3eb05697d2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6392,
            y: 548,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '375f3933-24c7-4ae8-b4bb-d6cca5c57c3a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6217,
            y: 802,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '573efac7-4b14-4ad6-800e-a93a59cfbb42',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6299,
            y: 730,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '896d23b7-7fd7-477f-b38a-f2896b3acf80',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6400,
            y: 643,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '214',
            data: '',
        },
        {
            id: '07d0db8f-d75b-41df-ab05-92439c2e6094',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7708,
            y: 805,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: 'cc7459dc-c176-4545-9ced-7ffd07f38074',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7828,
            y: 805,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '085c2f03-ceff-4881-977a-bebc421b0294',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7949,
            y: 811,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: 'c472c55a-cf1e-4498-87a1-37b464b0ebc0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7719,
            y: 689,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '4e3c12da-dc39-4c6b-b888-7fdfb47eef32',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7833,
            y: 700,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '85c6c1f5-654d-441d-b11b-4d9d20655b2a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7951,
            y: 696,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '8ed2eb14-84b5-4638-961d-1e4720f47a44',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7805,
            y: 584,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: 'a7d6222d-a5ae-4d9a-ad1b-dae73c18c935',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7933,
            y: 585,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: 'f0e2162c-66f5-4818-aebd-771a6b457c8d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7502,
            y: 40,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '266affd0-ebdf-4761-a965-d2c7f92c149a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7634,
            y: 12,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '4b932884-a790-4b22-b6d5-a43f842fee41',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7780,
            y: 3,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '23268afa-36fa-4e65-b308-982c35933128',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7929,
            y: 14,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: 'a496e474-d3a7-475a-91fd-33e35da2223a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7642,
            y: 105,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '2766e89d-3962-41bc-87a4-723b18af6177',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7790,
            y: 106,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: 'a3bc5733-cef7-428d-9322-6db9bf8b1b29',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7914,
            y: 114,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '7ff83037-f2f3-4dae-b023-58a281c1ae6b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7739,
            y: 196,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: 'fe808c7c-4a1a-42cb-b4ab-3255f94e357f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7881,
            y: 215,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: 'cf767453-3518-4e5c-8a1f-349aabe28bcf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8004,
            y: 194,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '92f98910-0ef5-4f81-b34a-3030edc786d7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7769,
            y: 292,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.75,
                y: 0.75,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_4',
            parent: '219',
            data: '',
        },
        {
            id: '9656da12-c939-4a99-933d-ada7dadc3628',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8824,
            y: 26,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '1b8d7530-55de-468e-aac1-a113e9340276',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8957,
            y: 29,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'c4d12883-6801-44f5-b465-621b21e2d8c4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9070,
            y: 50,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'b358431c-c37f-460e-88a4-2f31202f5041',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8618,
            y: 104,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '37421421-aca8-4314-b5a4-d412c84b4ab8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8739,
            y: 95,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'c068c9a2-637b-4be9-bfc7-38edc2866621',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8850,
            y: 102,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '6f4c6714-444e-4cf4-9905-99a2a14f1b1c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8964,
            y: 110,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'cc3942c2-74ec-4d0d-92c4-a3d27cf61fca',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8684,
            y: 196,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '36ccb2e6-624c-4706-9bc2-011784c1c86c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8831,
            y: 191,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '727ee889-af78-4d11-ae00-dff6548b35e9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9051,
            y: 163,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '0dde8678-94db-437f-acab-52710a2d78d4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8626,
            y: 293,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '5b9971c0-e761-43d4-ac45-94168bcc2dfb',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8757,
            y: 285,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '2b8685ec-1ce7-4a55-b757-8ed1eb980fea',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8957,
            y: 223,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'ab0bd164-02cd-4364-8aa1-2012d34fb97d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8874,
            y: 291,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '9e2012d9-531e-40d8-a0c2-b292fb901049',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8748,
            y: 573,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '411f0162-bda5-4457-ad6f-43598a7fbf94',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8650,
            y: 597,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'f70ae5cc-968a-46fe-94e2-a1a0a00758a4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8552,
            y: 652,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'a760d19f-e54b-46cf-a328-b3fcbc6c0501',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8855,
            y: 597,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'c9b6cfea-1ecb-4a19-bc4a-f355f91f037b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8742,
            y: 656,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '32f55238-6770-4c80-a7f6-ca3a3cfd1f1c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8639,
            y: 707,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '3bab6acd-67db-47ec-994b-ae5729a50c9d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8541,
            y: 797,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'a3c4fc70-f201-4923-ae73-3dce87448a72',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8955,
            y: 631,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '0fb588be-a311-49ab-a2fa-29f08c238d0b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8851,
            y: 683,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '7553e5de-0853-49d0-9618-1e1ba7e19051',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8763,
            y: 747,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'f5175e8d-bc48-4f3e-bbcd-d0c915eccd76',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8675,
            y: 820,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '8825eb90-13f3-42a0-9e1e-f9c20da84464',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8998,
            y: 732,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '4273ffd1-c887-48bb-81c8-aa96aca37a4b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8894,
            y: 755,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '6341aade-c1e3-4854-8902-6ca683158c27',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8804,
            y: 835,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: 'a99200a0-c07e-4316-9c07-efad69f389c1',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8965,
            y: 873,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '224',
            data: '',
        },
        {
            id: '339e0db6-7aa5-41cd-9ba1-b73417e0bb33',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9512,
            y: 42,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '22eae868-db9a-45c6-b6d6-7cb86b02cfc2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9632,
            y: 36,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '21c592ae-cb5c-45bf-8203-abfe121aca3c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9759,
            y: 36,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '385fff1b-a5ad-4a69-982c-3473f9a4a207',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9881,
            y: 36,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'f0c6b1ad-42a2-4326-b13c-6ec7dd059350',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9599,
            y: 127,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'afe7c5ea-d7c9-4c27-851e-15d5825b3a2d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9719,
            y: 124,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '1a8ed3c0-8a17-422a-ae1b-5997fed18749',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9846,
            y: 125,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '79bfc93a-7162-4a29-864c-be23e7827199',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9655,
            y: 217,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'c24b2957-f98e-4b43-8a74-486dff70f893',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9786,
            y: 218,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '183ebd34-72fe-4662-b082-d8824adc3d53',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9906,
            y: 206,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '7ac09446-31b5-4f30-8523-a64ef2fe5212',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9684,
            y: 309,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'e536d75c-4e6b-4a4b-901e-415f485a65f8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9964,
            y: 296,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'b756abd1-0ae6-4f22-89e3-16b9e4d5681f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9862,
            y: 301,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '0d73a69c-b0d1-42db-8a69-51061cc8e15e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9881,
            y: 386,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '57dcaa28-5be8-44fa-b621-49a221b33380',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9766,
            y: 355,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'b9c1c980-297a-43d7-8fa1-56ab3e04bf20',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9261,
            y: 568,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '5113f693-6ed3-4b05-9064-33722e78e52a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9369,
            y: 580,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'ee56d295-8c1a-4520-a0ee-78782b34602e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9296,
            y: 674,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'bee77649-2119-4de7-ab8a-a041ce7faf8e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9473,
            y: 563,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '37cff981-7bc0-4bba-9e49-996499cbd607',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9377,
            y: 761,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '5eb805f3-68a4-4bd4-8540-a717eb1a299d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9571,
            y: 623,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'c85d35b8-26cb-4237-9c3f-8be20cfe1d6a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9446,
            y: 670,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '5caf45ee-707d-4fd1-bb58-5c5126fa3862',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9594,
            y: 718,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '997c06d5-d5d7-4cd5-9b5c-02de477e5cd4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9712,
            y: 753,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '5e72304a-c822-4bed-8a2a-c1fc6ee4f6c3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9495,
            y: 802,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'cc1c5bd3-734b-44a8-a38a-2468186a90bc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9624,
            y: 843,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1105,
            y: 289,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '106',
            data: '',
        },
        {
            id: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1683,
            y: 596,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '160',
            data: '',
        },
        {
            id: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3844,
            y: 249,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '181',
            data: '',
        },
        {
            id: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4526,
            y: 531,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '210',
            data: '',
        },
        {
            id: '107',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5990,
            y: 242,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '215',
            data: '',
        },
        {
            id: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7970,
            y: 531,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '220',
            data: '',
        },
        {
            id: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8689,
            y: 580,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '225',
            data: '',
        },
        {
            id: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9807,
            y: 269,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '230',
            data: '',
        },
        {
            id: 'e9b75b1f-8160-4ef5-b5b9-9efa162189aa',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
            data: '',
        },
        {
            id: '85746295-e987-4e2b-a7d0-6791216b55a9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -27,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_harvest_map',
            parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
            data: '',
        },
        {
            id: '8760c148-9cef-4f28-9a17-22e855cf0c84',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
            data: '',
        },
        {
            id: '656a5808-34d6-4751-a733-6af98d163ac6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sweetpotato_harvest_map',
            parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
            data: '',
        },
        {
            id: 'c001f4bb-2f73-4bf8-8953-deb543c31f21',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
            data: '',
        },
        {
            id: 'c41c933b-373f-4a3d-bdc7-f748ce87c274',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_harvest_map',
            parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
            data: '',
        },
        {
            id: '16ac1fb4-d061-449e-87ad-02f0d5dff6e9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
            data: '',
        },
        {
            id: '958851db-006d-425c-afff-a85018a3cb2b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'grapefruit_harvest_map',
            parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
            data: '',
        },
        {
            id: '108',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '107',
            data: '',
        },
        {
            id: '109',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_harvest_map',
            parent: '107',
            data: '',
        },
        {
            id: '46aeb65d-4896-4557-9865-75ef0057e163',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
            data: '',
        },
        {
            id: 'ac0db26e-8010-4059-87b0-18b44d3c25ca',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'safflower_harvest_map',
            parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
            data: '',
        },
        {
            id: '03074616-c479-4d19-9e8c-855582627513',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
            data: '',
        },
        {
            id: '018bb44b-6ca0-491c-b479-368ca2fa6897',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_harvest_map',
            parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
            data: '',
        },
        {
            id: '2e08b7f7-57a1-4e7c-baf5-459d9f88afdd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
            data: '',
        },
        {
            id: 'c077834a-7855-43ec-a465-2f5ed5df5421',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'sugarcane_harvest_map',
            parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
            data: '',
        },
    ],
    version: '1.0.x',
} as const;

export class WorldLayout26 {
    static raw = raw;
    root: PIXI.Container;
    backgrounds: PIXI.Container;
    nodesContainer: PIXI.Container;
    cropsSectorA: PIXI.Container[];
    cropsSectorB: PIXI.Container[];
    signsSectorA: PIXI.Container[];
    signsSectorB: PIXI.Container[];

    constructor() {
        populate(this, raw);
    }
}
